import React from 'react';
import {SlotsPlaceholder} from '@wix/widget-plugins-ooi';
import {Cell} from '../Layouts/Cell/Cell';
import {ProductPageSlotIds} from '../../constants';
import {ProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';

function ProductPageTopSlotComponent({globals}: ProvidedGlobalProps) {
  const {renderProductPageSlots} = globals.experiments;
  if (renderProductPageSlots) {
    return (
      <Cell>
        <SlotsPlaceholder slotId={ProductPageSlotIds.ProductPageTop} />
      </Cell>
    );
  } else {
    return null;
  }
}

export const ProductPageTopSlot = withGlobalProps(ProductPageTopSlotComponent);
